const state = {
    isShow: false,
    backBtn: true,
    title: '',
    backFunc: null
}

const getters = {
    header(state) {
        return { ...state }
    },
}

const mutations = {
    setIsShow(state, isShow) {
        state.isShow = isShow
    },
    setTitle(state, title) {
        state.title = title
    },
    setBackBtn(state, backBtn) {
        state.backBtn = backBtn
    },
    setBackFunc(state, backFunc) {
        state.backFunc = backFunc
    },
}

const actions = {
    show({ commit }, payload = {}) {
        commit('setIsShow', true)
        commit('setTitle', payload.title)
        commit('setBackBtn', payload.backBtn)
        commit('setBackFunc', payload.backFunc)
    },
    hide({ commit }) {
        commit('setIsShow', false)
        commit('setTitle', '')
        commit('setBackBtn', false)
        commit('setBackFunc', null)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
